import AttentionAnalysissModal from './attention-analysiss-modal.vue'
export default AttentionAnalysissModal
